import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'
import { ToggleSettings } from './components/ToggleSettings'
import { workplaceSettingsActions } from 'srcReact/WorkplaceSettingsPage'

const RightsPermissions = ({ selectedWorkplace }) => {
  const { t } = useTranslation()

  const dispatch = useDispatch()
  const {
    workplaceSettings: {
      display: { righs_permissions }
    }
  } = useSelector((state) => state)

  const updateRightsPermissions = (key, value) => {
    const payload = {
      workplace_id: selectedWorkplace?.id,
      name: selectedWorkplace?.name,
      ...righs_permissions,
      [key]: value ? 1 : 0
    }
    dispatch(workplaceSettingsActions.updateRightsPermissions(payload))
  }

  return (
    <div className={styles.rightsPermissions}>
      <ToggleSettings
        title={t('workplaceSettings.rightsPermissions.memberRights.title')}
        subTitle={t('workplaceSettings.rightsPermissions.memberRights.subtitle', {
          workplace: selectedWorkplace?.name
        })}
        options={[
          {
            title: t('workplaceSettings.rightsPermissions.canCreateGroups.title'),
            isChecked: righs_permissions?.can_create_groups === 1 ? true : false,
            onChange: (value) => updateRightsPermissions('can_create_groups', value)
          }
          // {
          //   title: t('workplaceSettings.rightsPermissions.canCreatePublicGroups.title'),
          //   subTitle: t('workplaceSettings.rightsPermissions.canCreatePublicGroups.subtitle'),
          //   isChecked: righs_permissions?.can_create_public_groups === 1 ? true : false,
          //   onChange: (value) => updateRightsPermissions('can_create_public_groups', value)
          // },
          // {
          //   title: t('workplaceSettings.rightsPermissions.canCreatePrivateGroups.title'),
          //   subTitle: t('workplaceSettings.rightsPermissions.canCreatePrivateGroups.subtitle'),
          //   isChecked: righs_permissions?.can_create_public_groups === 1 ? true : false,
          //   onChange: (value) => updateRightsPermissions('can_create_private_groups', value)
          // }
        ]}
      />
    </div>
  )
}

export default RightsPermissions
